import React, { useState, memo, useEffect, Fragment } from "react";
import axios from 'axios';
import { useRecoilState } from "recoil";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { clinicState } from '../../../store/clinicState';

import { PrefOptionList } from '../../common/parts/PrefOptionList';
import { OpenOptionList } from '../parts/OpenOptionList';

export const ClinicBasicForm = (props) => {
  const { init_clinic } = props;
  const [clinicData, setClinicData] = useRecoilState(clinicState);
  const [isDisabled, setIsDisabled] = useState(true);

  const notify = (type, message) => {
    if (type === "success") {
      toast.success(message, {
        hideProgressBar: true
      });
    } else {
      toast.error(message, {
        hideProgressBar: true
      });
    }
  }

  const onChangeData = (e) => {
    setClinicData({
      ...clinicData,
      [e.target.name]: e.target.value,
    })
  };

  const onClickClinicUpdate = () => {
    console.log("onClickClinicUpdate!");
    setIsDisabled(false);
    var data = { clinic: { ...clinicData }};

    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    axios.patch(`/agent/clinics/${clinicData.id}`, data)
    .then(resp => {
      console.log("Clinic Update api ok");
      console.log(resp.data.updated_at);
      setClinicData({
        ...clinicData,
        updated_at: resp.data.updated_at,
      });
      notify("success", "Clinic Update Success!");
    })
    .catch(e => {
      console.log("Clinic Update api ng");
      console.log(e.response);
      setClinicData({ 
        ...clinicData,
        name: init_clinic.name,
        zipcode: init_clinic.zipcode,
        prefecture_code: init_clinic.prefecture_code,
        area: init_clinic.area,
        address: init_clinic.address,
        tel: init_clinic.tel,
        fax: init_clinic.fax,
        email: init_clinic.email,
        url: init_clinic.url,
        staff: init_clinic.staff,
        access: init_clinic.access,
        special_notes: init_clinic.special_notes,
        enabled: init_clinic.enabled,
        directly_booking: init_clinic.directly_booking,
        delivery_beforehand: init_clinic.delivery_beforehand,
        notes: init_clinic.notes,
        mon_open: init_clinic.mon_open,
        tue_open: init_clinic.tue_open,
        wed_open: init_clinic.wed_open,
        thu_open: init_clinic.thu_open,
        fri_open: init_clinic.fri_open,
        sat_open: init_clinic.sat_open,
        sun_open: init_clinic.sun_open,
        holiday_open: init_clinic.holiday_open,
        open_comment: init_clinic.open_comment,
      });
      alert(JSON.parse(e.request.responseText).errors);
      notify("error", "Clinic Update Error!");
    })
    .finally(()=> {
      setIsDisabled(true);
    });
  }

  return (
    <>
      <ToastContainer />
      <div className="card mt-3">
        <div className="card-header">
          <div className="row">
            <div className="col-auto me-auto h4 mt-1">基本情報</div>
            <div className="col-4">
              <div className="input-group">
                <span className="input-group-text" id="title-basic-updated_at">更新日：</span>
                <input type="text" className="form-control" id="basic-updated_at" value={clinicData.updated_at} disabled />
              </div>
            </div>
          </div>
        </div>

        <div className="card-body">
          <div className="row">
            <div className="col">
              <div className="input-group mb-3">
                <span className="input-group-text" id="title-basic-name">医療機関名</span>
                <input type="text" name="name" className="form-control" id="basic-name" value={clinicData.name} onChange={onChangeData} />
              </div>
            </div>
            <div className="col-3">
              <div className="input-group mb-3">
                <span className="input-group-text" id="title-basic-clinic_code">医療ID</span>
                <input type="text" className="form-control" id="basic-clinic_code" defaultValue={clinicData.clinic_code} disabled />
              </div>
            </div>
          </div>

          <div className="input-group mb-3">
            <span className="input-group-text" id="title-basic-special_notes">特記事項（公開）</span>
            <textarea type="text" name="special_notes" className="form-control" id="basic-special_notes" rows="3" placeholder="公開用備考" defaultValue={clinicData.special_notes} onChange={onChangeData}></textarea>
          </div>

          <div className="row">
            <div className="col-3">
              <div className="input-group mb-3">
                <span className="input-group-text" id="title-basic-url">URL：</span>
                <input type="text" name="url" className="form-control" id="basic-url" defaultValue={clinicData.url} onChange={onChangeData} />
              </div>
            </div>
            <div className="col-3">
              <div className="input-group mb-3">
                <span className="input-group-text" id="title-basic-enabled">受付状況</span>
                <select name="enabled" id="basic-enabled" className="form-select" defaultValue={clinicData.enabled} onChange={onChangeData}>
                  <option value="true">可</option>
                  <option value="false">不可</option>
                </select>
              </div>
            </div>
            <div className="col-3">
              <div className="input-group mb-3">
                <span className="input-group-text" id="title-basic-directly_booking">直接予約</span>
                <select name="directly_booking" id="basic-directly_booking" className="form-select" defaultValue={clinicData.directly_booking} onChange={onChangeData}>
                  <option value="0">不明</option>
                  <option value="1">可能</option>
                  <option value="2">不可</option>
                </select>
              </div>
            </div>
            <div className="col-3">
              <div className="input-group mb-3">
                <span className="input-group-text" id="title-basic-delivery_beforehand">事前送付物</span>
                <select name="delivery_beforehand" id="basic-delivery_beforehand" className="form-select" defaultValue={clinicData.delivery_beforehand} onChange={onChangeData}>
                  <option value="0">不明</option>
                  <option value="1">あり</option>
                  <option value="2">なし</option>
                </select>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col">
              <div className="input-group mb-3">
                <span className="input-group-text" id="title-basic-prefecture_code">所在地</span>
                <input type="text" name="zipcode" className="form-control" id="basic-zipcode" placeholder="郵便番号" defaultValue={clinicData.zipcode} onChange={onChangeData} />
                <select name="prefecture_code" className="form-select" id="basic-prefecture_code" defaultValue={clinicData.prefecture_code} onChange={onChangeData} >
                  <PrefOptionList />
                </select>
                <input type="text" name="area" className="form-control" id="basic-area" placeholder="市区町村名" defaultValue={clinicData.area} onChange={onChangeData} />
                <input type="text" name="address" className="form-control w-50" id="basic-address" placeholder="住所" defaultValue={clinicData.address} onChange={onChangeData} />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-3">
              <div className="input-group mb-3">
                <span className="input-group-text" id="title-basic-staff">担当者</span>
                <input type="text" className="form-control" name="staff" id="basic-tel" defaultValue={clinicData.staff} onChange={onChangeData} />
              </div>
            </div>
            <div className="col-3">
              <div className="input-group mb-3">
                <span className="input-group-text" id="title-basic-tel">TEL</span>
                <input type="text" className="form-control" name="tel" id="basic-tel" defaultValue={clinicData.tel} onChange={onChangeData} />
              </div>
            </div>
            <div className="col-3">
              <div className="input-group mb-3">
                <span className="input-group-text" id="title-basic-fax">FAX</span>
                <input type="text" className="form-control" name="fax" id="basic-tel" defaultValue={clinicData.fax} onChange={onChangeData} />
              </div>
            </div>
            <div className="col-3">
              <div className="input-group mb-3">
                <span className="input-group-text" id="title-basic-email">Email</span>
                <input type="text" className="form-control" name="email" id="basic-email" defaultValue={clinicData.email} onChange={onChangeData} />
              </div>
            </div>
          </div>

          <table className="table table-bordered table-condensed mb-3">
            <thead>
              <tr className="bg-light">
                <th>月</th><th>火</th><th>水</th><th>木</th><th>金</th><th>土</th><th>日</th><th>祝</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <select name="mon_open" className="form-select" id="basic-mon_open" defaultValue={clinicData.mon_open} onChange={onChangeData} >
                    <OpenOptionList />
                  </select>
                </td>
                <td>
                  <select name="tue_open" className="form-select" id="basic-tue_open" defaultValue={clinicData.tue_open} onChange={onChangeData} >
                    <OpenOptionList />
                  </select>
                </td>
                <td>
                  <select name="wed_open" className="form-select" id="basic-wed_open" defaultValue={clinicData.wed_open} onChange={onChangeData} >
                    <OpenOptionList />
                  </select>
                </td>
                <td>
                  <select name="thu_open" className="form-select" id="basic-thu_open" defaultValue={clinicData.thu_open} onChange={onChangeData} >
                    <OpenOptionList />
                  </select>
                </td>
                <td>
                  <select name="fri_open" className="form-select" id="basic-fri_open" defaultValue={clinicData.fri_open} onChange={onChangeData} >
                    <OpenOptionList />
                  </select>
                </td>
                <td>
                  <select name="sat_open" className="form-select" id="basic-sat_open" defaultValue={clinicData.sat_open} onChange={onChangeData} >
                    <OpenOptionList />
                  </select>
                </td>
                <td>
                  <select name="sun_open" className="form-select" id="basic-sun_open" defaultValue={clinicData.sun_open} onChange={onChangeData} >
                    <OpenOptionList />
                  </select>
                </td>
                <td>
                  <select name="holiday_open" className="form-select" id="basic-holiday_open" defaultValue={clinicData.holiday_open} onChange={onChangeData} >
                    <OpenOptionList />
                  </select>
                </td>
              </tr>
            </tbody>
          </table>

          <div className="row">
            <div className="col-6">
              <div className="input-group mb-3">
                <span className="input-group-text" id="title-basic-open_comment">営業備考（公開）</span>
                <textarea type="text" name="open_comment" className="form-control" id="basic-open_comment" cols="30" rows="5" placeholder="営業備考（公開）" defaultValue={clinicData.open_comment} onChange={onChangeData}></textarea>
              </div>
            </div>
            <div className="col-6">
              <div className="input-group mb-3">
                <span className="input-group-text" id="title-basic-notes">注意事項（KP用）</span>
                <textarea type="text" name="notes" className="form-control" id="basic-notes" cols="30" rows="5" placeholder="営業備考（公開）" defaultValue={clinicData.notes} onChange={onChangeData}></textarea>
              </div>
            </div>
          </div>

        </div>
        <div className="card-footer text-center">
          <button 
            className="btn btn-primary text-white w-25" 
            onClick={onClickClinicUpdate}
            disabled={
              isDisabled
              && clinicData.name ? false : true
            }
          >
            内容更新
          </button>
        </div>
      </div>
    </>
  );
};